import { createBaseAction } from '@essent/common';

export const initMarketingProfile = createBaseAction(
  '[Customer profile] Init marketing profile'
);
